import {useEffect} from 'react';
import {analyticsHandler} from '@/services/analytics/analytics-handler';
import {AnalyticsPropertyMaxLength} from '@/services/analytics/analytics-types';
import {MaxLengthString} from '@/types/utils';

export const useWebViewContentOnDialogAppear = <T extends string>(
  contentName: MaxLengthString<T, AnalyticsPropertyMaxLength>,
  contentDetail: string | null,
  isVisible: boolean,
) =>
  useEffect(() => {
    if (!isVisible) {
      return;
    }

    analyticsHandler.webViewContent({
      content_name: contentName,
      content_detail: contentDetail,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps -- only run when dialog visibility changes
  }, [isVisible]);
